// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"e2f441f9","65":"bfc186f5","175":"fae9bc5b","275":"cf4e06fe","293":"ffd4b93c","294":"0acc89b3","321":"faaad2ba","346":"5f3db82a","488":"8be44285","551":"ad7e7585","638":"144476cc","775":"7ec09af6","793":"0452b08d","894":"6c00ae08","927":"cd0814a5"}[chunkId] + ".chunk.js";
};